// Each entry defines a tab in the connector filter on SyncDetails.
// key: unique identifier used in state, label: displayed tab text,
// startedByValues: list of StartedBy values that belong to this group (empty = show all).
export const CONNECTOR_GROUPS = [
  { key: 'all', label: 'All', startedByValues: [] },
  { key: 'intune', label: 'Intune', startedByValues: ['IntuneSyncOrchestrator', 'SummaryTasksSubOrchestrator', 'GraphSharedItemsSubOrchestrator'] },
  { key: 'lenovo', label: 'Lenovo', startedByValues: ['LenovoWarrantySubOrchestrator'] },
  { key: 'loganalytics', label: 'Log Analytics', startedByValues: ['LogAnalyticsSubOrchestrator'] },
  { key: 'dell', label: 'Dell', startedByValues: ['DellWarrantySubOrchestrator'] },
  { key: 'surface', label: 'Surface', startedByValues: ['SurfaceWarrantySubOrchestrator'] },
  { key: 'nist', label: 'Nist', startedByValues: ['NistCpeSyncOrchestrator', 'NistCveSyncOrchestrator', 'NISTXMLSubOrchestrator', 'NISTSubOrchestrator', 'NistSyncOrchestrator', 'NistCveCosmosToSqlSyncOrchestrator'] },
  { key: 'indvidual', label: 'Individual Sync', startedByValues: ['SyncIndividualTable'] }
];
